// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sticky-thead thead {
  position: sticky;
  top: 0;
  background: rgb(248,249,250) !important;
  z-index: 2;
  padding: 4px !important;
}

.request-table {
    max-height: 360px;
    overflow-y: auto;
    overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/styles/request.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,uCAAuC;EACvC,UAAU;EACV,uBAAuB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".sticky-thead thead {\n  position: sticky;\n  top: 0;\n  background: rgb(248,249,250) !important;\n  z-index: 2;\n  padding: 4px !important;\n}\n\n.request-table {\n    max-height: 360px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
